import { useState, useEffect } from 'react';

const CodeTypingAnimation = () => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const codeSnippets = [
    `const developer = {
  name: 'Jürgen Belada',
  skills: ['React', 'TypeScript', 'C#'],
  passion: 'Innovation'
};`,
    `function buildAmazingApps() {
  const creativity = true;
  const expertise = 'advanced';
  return creativity + expertise;
}`,
    `class DigitalSolutions {
  constructor() {
    this.quality = 'premium';
    this.delivery = 'on-time';
  }
}`,
    `async function createFuture() {
  const vision = await getIdeas();
  const code = transform(vision);
  return deploy(code);
}`
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      const current = codeSnippets[currentTextIndex];
      
      if (!isDeleting) {
        setCurrentText(current.substring(0, currentText.length + 1));
        
        if (currentText === current) {
          setTimeout(() => setIsDeleting(true), 2000);
        }
      } else {
        setCurrentText(current.substring(0, currentText.length - 1));
        
        if (currentText === '') {
          setIsDeleting(false);
          setCurrentTextIndex((prev) => (prev + 1) % codeSnippets.length);
        }
      }
    }, isDeleting ? 30 : 100);

    return () => clearTimeout(timeout);
  }, [currentText, isDeleting, currentTextIndex, codeSnippets]);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute top-1/4 left-10 transform -rotate-12 opacity-20">
        <pre className="text-cyber-blue text-sm font-mono bg-background/5 p-4 rounded-lg backdrop-blur-sm border border-cyber-blue/20">
          {currentText}
          <span className="animate-pulse">|</span>
        </pre>
      </div>
      
      <div className="absolute bottom-1/3 right-10 transform rotate-6 opacity-15">
        <pre className="text-cyber-purple text-xs font-mono bg-background/5 p-3 rounded-lg backdrop-blur-sm border border-cyber-purple/20">
          {`// Building the future
const innovation = true;
console.log('✨ Magic happens here');`}
        </pre>
      </div>
      
      <div className="absolute top-1/2 left-1/3 transform -rotate-6 opacity-10">
        <pre className="text-cyber-green text-xs font-mono bg-background/5 p-3 rounded-lg backdrop-blur-sm border border-cyber-green/20">
          {`<Component>
  <Innovation />
  <Quality assured={true} />
</Component>`}
        </pre>
      </div>
      
      {/* Floating code particles */}
      <div className="absolute top-20 right-1/4 animate-float opacity-30">
        <span className="text-cyber-blue font-mono text-lg">{`{}`}</span>
      </div>
      <div className="absolute bottom-40 left-1/4 animate-float opacity-25" style={{ animationDelay: '2s' }}>
        <span className="text-cyber-purple font-mono text-xl">{`</>`}</span>
      </div>
      <div className="absolute top-1/3 right-1/3 animate-float opacity-20" style={{ animationDelay: '4s' }}>
        <span className="text-cyber-green font-mono text-lg">{`( )`}</span>
      </div>
    </div>
  );
};

export default CodeTypingAnimation;